module.exports = __webpack_public_path__ + "img/801b3da.jpg";